// src/services/httpClientInCorporate.js
// httpClientInCorporate — เชื่อมต่อกับ new_dtime_corporate_service_node_backend
// (แยกออกมาจาก httpClientImmigration เพราะ Incorporate & Corporate module
// ถูกย้ายไปเป็น service อิสระของตัวเอง ไม่ได้ฝากอยู่กับ immigration service แล้ว)

import axios from "axios";
import {
  server,
  apiUrlInCorporate,
  NOT_CONNECT_NETWORK,
  NETWORK_CONNECTION_MESSAGE,
} from "@/services/constants";
import router from "@/router";
import api from "@/services/api";

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

const httpClientInCorporate = axios.create({
  baseURL: apiUrlInCorporate,
});

httpClientInCorporate.interceptors.request.use(async (config) => {
  if (!isAbsoluteURLRegex.test(config.url)) {
    const userToken = localStorage.getItem(server.TOKEN_KEY);
    if (userToken) {
      config.headers = {
        "x-access-token": userToken,
        authorization: `Bearer ${userToken}`,
      };
    }
    config.url = apiUrlInCorporate + "/" + config.url;
    // console.log("httpClientInCorporate:" + config.url);
  }
  config.timeout = 120000;
  return config;
});

httpClientInCorporate.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    } else if (!error.response) {
      return Promise.reject({
        code: NOT_CONNECT_NETWORK,
        message: NETWORK_CONNECTION_MESSAGE,
      });
    }
    const { response } = error;
    if (response.status === 401) {
      api.logoff();
      router.push("/login").catch(() => {});
    } else {
      router.push("/");
    }
    return Promise.reject(error);
  },
);

export default httpClientInCorporate;
